var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      class: ["llp-modal", { mobile: _vm.isMobile(_vm.$mq) }],
      attrs: { "show-close-button": true },
      on: {
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "image" }, [
          _c(
            "video",
            {
              staticClass: "media-video",
              attrs: {
                preload: "auto",
                autoplay: "",
                muted: "",
                loop: "",
                playsinline: ""
              },
              domProps: { muted: true }
            },
            [_c("source", { attrs: { src: _vm.videoSrc, type: "video/mp4" } })]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "llp-text" }, [
          _c("h1", [
            _vm._v(
              "Welcome to the new " +
                _vm._s(_vm.learningPath.short_title) +
                " learning path"
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.levelText))])
        ])
      ]),
      _vm._v(" "),
      !!_vm.ctaUrl
        ? _c(
            "a",
            { staticClass: "button btn-black", attrs: { href: _vm.ctaUrl } },
            [_vm._v("Continue learning")]
          )
        : _c(
            "button",
            {
              staticClass: "button btn-black",
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_vm._v("Continue learning")]
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }